// 表单重置
export function resetForm(refName) {
    if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
    }
}

// 回显数据字典
export function selectDictLabel(datas, value) {
    var actions = [];
    Object.keys(datas).some((key) => {
        if (datas[key].id == ('' + value)) {
            actions.push(datas[key].name);
            return true;
        }
    })
    return actions.join('');
}


// 回显数据字典(城市)
export function TreeDictLabel(datas, value) {
    const stack = []
    let going = true
    const walker = (array, id) => {
        array.forEach(item => {
            if (!going) return
            stack.push(item.regionName)
            if (item['regionCode'] === id) {
                going = false
            } else if (item['children']) {
                walker(item['children'], id)
            } else {
                stack.pop()
            }
        })
        if (going) stack.pop()
    }
    walker(datas, value)
    // console.log(stack)
    stack.length>1 ? stack.shift() : ""
    // stack.shift()
    // let newStack = JSON.parse(JSON.stringify(stack))
    // //  层级过滤处理   三级 删除一级
    // if ( newStack.length===3){
    //     stack.shift()
    // }
    // //  四级删除连后两级
    // if (newStack.length===4){
    //     stack.pop()
    //     stack.shift()
    // }


    return  stack.join('/');
}


// 回显数据字典(行业)
export function industryTreeDictLabel(datas, value) {
    const stack = []
    let going = true
    const walker = (array, id) => {
        array.forEach(item => {
            if (!going) return
            stack.push(item.name)
            if (item['code'] === id) {
                going = false
            } else if (item['children']) {
                walker(item['children'], id)
            } else {
                stack.pop()
            }
        })
        if (going) stack.pop()
    }
    walker(datas, value)
    // stack.shift()
    // let newStack = JSON.parse(JSON.stringify(stack))
    // //  层级过滤处理   三级 删除一级
    // if ( newStack.length===3){
    //     stack.shift()
    // }
    // //  四级删除连后两级
    // if (newStack.length===4){
    //     stack.pop()
    //     stack.shift()
    // }


    return stack.join('/');
}



const toString = Object.prototype.toString

export function is(val, type) {
    return toString.call(val) === `[object ${type}]`
}


export function isNumber(val) {
    return is(val, 'Number')
}
